import React, { useState, useEffect } from "react";
import UserAvatar from "../../Components/UserAvatar/UserAvatar2";
import { Link } from "react-router-dom";
import Tabs from "../../Components/Tabs/Tabs";
import "../Container/HomeContainer.css";
import "../Container/HomeContainer2.css";
import { GridColumn, GridRow, Icon, Segment } from "semantic-ui-react";
import { CircularProgressbar } from "react-circular-progressbar";
import { Grid, Responsive } from "semantic-ui-react";
import { getTeacherType } from "../../Helper";

const TeacherInfoHeader = (props) => {
  const user = props.user;

  const img_check = () => {
    if (user.img_url) {
      if (user.img_url != "") {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const avai_check =
    user.rules &&
    user.rules.length > 0 &&
    Object.keys(user.rules[0]).length > 0;

  const perDetail_check = () => {
    if (
      !user.first_name ||
      !user.last_name ||
      !user.contact_number ||
      !user.address_line1 ||
      !user.suburb ||
      !user.state ||
      !user.postcode
    ) {
      return false;
    } else {
      return true;
    }
  };

  const id_check = () => {
    if (
      !user.id_document_type ||
      !user.identification_document_number ||
      !user.issuing_place ||
      !user.id_document_expiry ||
      !user.identification_filename
    ) {
      return false;
    } else {
      return true;
    }
  };

  const referee_check = user.referees.length > 0;

  const quali_check = () => {
    if (user.qualifications) {
      if (user.qualifications.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const proEx_check = user.professional_experience.length > 0;

  const get_progress = () => {
    var progress = 0;
    const pro_list = [
      img_check(),
      avai_check,
      id_check(),
      referee_check,
      quali_check(),
      proEx_check,
      perDetail_check(),
      false,
    ];
    for (var i = 0; i < pro_list.length; i++) {
      if (pro_list[i]) {
        progress += 1;
      }
    }
    progress = (progress / pro_list.length) * 100;
    return progress;
  };

  var bd_check = user.has_bank_detail;

  var progress = get_progress();

  return (
    <div>
      <div className="home-container-teacher-info">
        <div className={"user-avatar-box teacher-info-avatar2"}>
          <div className="avatar-wrapper">
            <img
              src={user.img_url}
              className="user-avatar-img"
              alt="user's avatar"
            />
          </div>
        </div>

        <div className="home-teacher-name">
          <h1>
            {user.preferred_name && user.preferred_name !== user.first_name
              ? user.first_name[0].toUpperCase() +
                user.first_name.slice(1) +
                " (" +
                user.preferred_name[0].toUpperCase() +
                user.preferred_name.slice(1) +
                ") "
              : user.first_name[0].toUpperCase() +
                user.first_name.slice(1)}{" "}
            {user.last_name.toUpperCase()}
          </h1>
          <h2 className="h-secondary">{getTeacherType(user)}</h2>
          <h2 className="h-secondary">
            <i className="mdi mdi-map-marker">
              {" "}
              {[user.preferred_online ? "Online" : false,
                user.preferred_city1, user.preferred_city2, user.preferred_city3].filter(Boolean).join(", ")}
            </i>{" "}
          </h2>
        </div>
      </div>
      <br />
      <div
        hidden={window.location.pathname != "/TeacherpersonalDetails"}
        className="mx-6 py-6 progress-wrapper"
      >
        <div className="row">
          {/* this is the left part of the progress bar to show percentage */}
          <div className="col-md-2">
            <div className="row">
              <div className="col-md-2"></div>
              <div className="col-md-8">
                <CircularProgressbar value={progress} text={`${progress}%`} />
                <p className="text-center font-weight-bold pt-md-2">
                  {" "}
                  Setup process
                </p>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>

          {/* this is the right part of the progress bar to show progress details */}
          <div className="col-md-10">
            <div className="row">
              <div className="col-md-3">
                <Responsive minWidth={768}>
                  <GridRow className="py-3">
                    <Grid.Column>
                      {img_check() ? (
                        <div className="rounded-circle tick-on-icon">
                          <Icon
                            name="blue thumbs up outline icon"
                            size="large"
                            className=""
                          ></Icon>
                        </div>
                      ) : (
                        <div className="rounded-circle tick-off-icon">
                          <Icon size="large" className="pl-md-2 pt-md-2"></Icon>
                        </div>
                      )}
                    </Grid.Column>
                    <Grid.Column>
                      {/*<p className="pl-md-3 pt-md-3"> Add Profile Photo</p>*/}
                      <p className="pl-md-3 pt-md-3"> Add Profile Photo</p>
                    </Grid.Column>
                  </GridRow>

                  <GridRow className="py-3">
                    <Grid.Column>
                      {perDetail_check() ? (
                        <div className="rounded-circle tick-on-icon">
                          <Icon
                            name="blue thumbs up outline icon"
                            size="large"
                            className=""
                          ></Icon>
                        </div>
                      ) : (
                        <div className="rounded-circle tick-off-icon">
                          <Icon size="large" className="pl-md-2 pt-md-2"></Icon>
                        </div>
                      )}
                    </Grid.Column>
                    <Grid.Column>
                      {/*<p className="pl-md-3 pt-md-3">*/}
                      {/*Add Referee*/}
                      {/*</p>*/}
                      <p className="pl-md-3 pt-md-3"> Add Personal Details</p>
                    </Grid.Column>
                  </GridRow>
                </Responsive>
              </div>

              <div className="col-md-3 pl-md-0">
                <Responsive minWidth={768}>
                  <GridRow className="py-3">
                    <Grid.Column>
                      {quali_check() ? (
                        <div className="rounded-circle tick-on-icon">
                          <Icon
                            name="blue thumbs up outline icon"
                            size="large"
                            className=""
                          ></Icon>
                        </div>
                      ) : (
                        <div className="rounded-circle tick-off-icon">
                          <Icon size="large" className="pl-md-2 pt-md-2"></Icon>
                        </div>
                      )}
                    </Grid.Column>
                    <Grid.Column>
                      {/*<p className="pl-md-3 pt-md-3"> Add Qualifications</p>*/}
                      <p className="pl-md-3 pt-md-3"> Add Qualifications</p>
                    </Grid.Column>
                  </GridRow>

                  <GridRow className="py-3">
                    <Grid.Column>
                      {id_check() ? (
                        <div className="rounded-circle tick-on-icon">
                          <Icon
                            name="blue thumbs up outline icon"
                            size="large"
                            className=""
                          ></Icon>
                        </div>
                      ) : (
                        <div className="rounded-circle tick-off-icon">
                          <Icon size="large" className="pl-md-2 pt-md-2"></Icon>
                        </div>
                      )}
                    </Grid.Column>
                    <Grid.Column>
                      {/*<p className="pl-md-3 pt-md-3"> Add Identification</p>*/}
                      <p className="pl-md-3 pt-md-3"> Add Identification</p>
                    </Grid.Column>
                  </GridRow>
                </Responsive>
              </div>

              <div className="col-md-3">
                <Responsive minWidth={768}>
                  <GridRow className="py-3">
                    <Grid.Column>
                      {proEx_check ? (
                        <div className="rounded-circle tick-on-icon">
                          <Icon
                            name="blue thumbs up outline icon"
                            size="large"
                            className=""
                          ></Icon>
                        </div>
                      ) : (
                        <div className="rounded-circle tick-off-icon">
                          <Icon size="large" className="pl-md-2 pt-md-2"></Icon>
                        </div>
                      )}
                    </Grid.Column>
                    <Grid.Column>
                      {/*<p className="pl-md-3 pt-md-3"> Add Experience</p>*/}
                      <p className="pl-md-3 pt-md-3"> Add Experience</p>
                    </Grid.Column>
                  </GridRow>

                  <GridRow className="py-3">
                    <Grid.Column>
                      {avai_check ? (
                        <div className="rounded-circle tick-on-icon">
                          <Icon
                            name="blue thumbs up outline icon"
                            size="large"
                            className=""
                          ></Icon>
                        </div>
                      ) : (
                        <div className="rounded-circle tick-off-icon">
                          <Icon size="large" className="pl-md-2 pt-md-2"></Icon>
                        </div>
                      )}
                    </Grid.Column>
                    <Grid.Column>
                      {/*<p className="pl-md-3 pt-md-3"> Add Availability</p>*/}
                      <p className="pl-md-3 pt-md-3"> Add Availability</p>
                    </Grid.Column>
                  </GridRow>
                </Responsive>
              </div>

              <div className="col-md-3">
                <Responsive minWidth={768}>
                  <GridRow className="py-3">
                    <Grid.Column>
                      {referee_check ? (
                        <div className="rounded-circle tick-on-icon">
                          <Icon
                            name="blue thumbs up outline icon"
                            size="large"
                            className=""
                          ></Icon>
                        </div>
                      ) : (
                        <div className="rounded-circle tick-off-icon">
                          <Icon size="large" className="pl-md-2 pt-md-2"></Icon>
                        </div>
                      )}
                    </Grid.Column>
                    <Grid.Column>
                      {/*<p className="pl-md-3 pt-md-3"> Add Referee</p>*/}
                      <p className="pl-md-3 pt-md-3"> Add Referee</p>
                    </Grid.Column>
                  </GridRow>

                  <GridRow className="py-3">
                    <Grid.Column>
                      {bd_check ? (
                        <div className="rounded-circle tick-on-icon">
                          <Icon
                            name="blue thumbs up outline icon"
                            size="large"
                            className=""
                          ></Icon>
                        </div>
                      ) : (
                        <div className="rounded-circle tick-off-icon">
                          <Icon size="large" className="pl-md-2 pt-md-2"></Icon>
                        </div>
                      )}
                    </Grid.Column>
                    <Grid.Column>
                      {/*<p className="pl-md-3 pt-md-3"> Add Bank Details </p>*/}
                      <p className="pl-md-3 pt-md-3"> Add Bank Details</p>
                    </Grid.Column>
                  </GridRow>
                </Responsive>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherInfoHeader;
